import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexGroups',
  setup(__props) {

const buttonAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/buttonAddons.vue"))
const customForms = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/customForms.vue"))
const fileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/fileInput.vue"))
const buttonsDropdowns = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/buttonsDropdowns.vue"))
const segmentedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/segmentedButtons.vue"))
const checkboxesRadios = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/checkboxesRadios.vue"))
const sizingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/sizingInput.vue"))
const multipleInputs = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/multipleInputs.vue"))
const basicInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/basicInput.vue"))
const variationAddons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/inputgroups/variationAddons.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      title: "Input Groups"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(buttonAddons)),
        _createVNode(_unref(customForms)),
        _createVNode(_unref(fileInput)),
        _createVNode(_unref(buttonsDropdowns)),
        _createVNode(_unref(segmentedButtons)),
        _createVNode(_unref(checkboxesRadios)),
        _createVNode(_unref(sizingInput)),
        _createVNode(_unref(multipleInputs)),
        _createVNode(_unref(basicInput)),
        _createVNode(_unref(variationAddons))
      ])
    ])
  ], 64))
}
}

})